import React from 'react';
import PropTypes from 'prop-types';
import { FaInfoCircle } from 'react-icons/fa';

const MultiTaxNonUSTaxAmountInfo = ({ hidden }) => {
  if (hidden) {
    return null;
  }
  return (
    <div className="d-flex align-items-center amount-info-wrapper">
      <FaInfoCircle size={35} />
      The Pre-Tax Adjustment amount will be applied to all Country Tax Types for a Multi-Tax NonUS entity,
      regardless of the Country Tax Type selected.
    </div>
  );
};

MultiTaxNonUSTaxAmountInfo.propTypes = {
  hidden: PropTypes.bool,
};

export default MultiTaxNonUSTaxAmountInfo;
